import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/plane.svg
 */
const IconPlane: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M12.034 18.331a.694.694 0 01-.313-.075L.46 12.626a.705.705 0 11.626-1.252l11.26 5.631a.702.702 0 01-.313 1.335v-.009z"
      fill="currentColor"
    />
    <path
      d="M.768 12.7a.704.704 0 01-.313-1.337l11.26-5.63a.7.7 0 01.939.314.707.707 0 01-.313.937L1.08 12.614a.675.675 0 01-.312.085z"
      fill="currentColor"
    />
    <path
      d="M23.304 12.7a.691.691 0 01-.313-.077l-11.26-5.63a.702.702 0 01.123-1.244.704.704 0 01.503-.006l11.26 5.63a.709.709 0 01-.313 1.336v-.01z"
      fill="currentColor"
    />
    <path
      d="M12.034 18.332a.704.704 0 01-.313-1.335l11.26-5.63a.703.703 0 01.626 1.25l-11.26 5.631a.682.682 0 01-.313.084zM6.401 15.514a.706.706 0 01-.313-1.333l11.26-5.63a.703.703 0 11.626 1.251l-11.26 5.631a.752.752 0 01-.313.081z"
      fill="currentColor"
    />
    <path
      d="M17.667 15.513a.73.73 0 01-.313-.072l-11.26-5.63a.7.7 0 01-.387-.975.708.708 0 01.445-.365.703.703 0 01.568.089l11.26 5.63a.703.703 0 01-.313 1.332v-.009z"
      fill="currentColor"
    />
  </svg>
);

export default IconPlane;
